<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :title="station.id ? '编辑' : '新建'"
    width="1200px"
    top="5vh"
    @close="resetForm"
  >
    <el-form ref="form" :model="station" :rules="ruleValidate" label-width="140px" label-suffix=" :">
      <div class="fm-section-title">编码标识</div>
      <el-row :gutter="10">
        <el-col v-if="station.id" :span="6">
          <el-form-item label="工位编码">
            <el-input v-model="station.stationCode" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="工位全称" prop="stationName">
            <el-input v-model="station.stationName" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="工位简称">
            <el-input v-model="station.stationShortName" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="英文名称">
            <el-input v-model="station.stationEnglishName" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="ERP编码">
            <el-input v-model="station.stationERPCode" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="WMS编码">
            <el-input v-model="station.stationWMSCode" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="WCS编码">
            <el-input v-model="station.stationWCSCode" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="SCADA编码">
            <el-input v-model="station.stationSCADACode" />
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">归属与分类</div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="所属产线" prop="lineID">
            <el-input v-model="lineName" placeholder="请选择所属产线" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.lineSelect.open()"></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="所属工序">
            <el-input v-model="processName" placeholder="请输入所属工序" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="工位类型" prop="stationType">
            <el-select v-model="station.stationType" clearable>
              <el-option v-for="item in stationTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="工位状态" prop="stationStatus">
            <el-select v-model="station.stationStatus" clearable>
              <el-option v-for="item in stationStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="全自动工位">
            <el-radio-group v-model="station.isAutoStation">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="关键工位">
            <el-radio-group v-model="station.isKeyStation">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">质量管控</div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="关键工序">
            <el-radio-group v-model="station.isKeyProcess">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="首件检验">
            <el-radio-group v-model="station.needFirstArticleCheck">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="过程巡检IPQC">
            <el-radio-group v-model="station.needIPQC">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="追溯等级">
            <el-select v-model="station.traceLevel" clearable>
              <el-option v-for="item in traceLevelOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">备注</div>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="工位备注">
            <el-input v-model="station.remark" type="textarea" :rows="2" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="扩展字段">
            <el-input v-model="station.extendJson" type="textarea" :rows="2" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <CommonSelect
      ref="lineSelect"
      title="选择产线"
      url="fm/production-mangeline"
      :columns="lineColumns"
      :search-items="lineSearchItems"
      :filter="lineFilter"
      @select="selectLine"
    />

    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CommonSelect from "../CommonSelect";

export default {
  components: { CommonSelect },
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      lineName: "",
      processName: "",
      lineFilter: {
        lineCode: "",
        lineName: "",
      },
      lineSearchItems: [
        { key: "lineCode", label: "产线编码", placeholder: "请输入产线编码" },
        { key: "lineName", label: "产线全称", placeholder: "请输入产线全称" },
      ],
      lineColumns: [
        { title: "产线编码", key: "lineCode", width: 120, align: "center" },
        { title: "产线全称", key: "lineName" },
        { title: "产线简称", key: "lineShortName", width: 120 },
        { title: "操作", slot: "action", width: 80, align: "center" },
      ],
      stationTypeOptions: [
        { label: "组装", value: 1 },
        { label: "SMT贴片", value: 2 },
        { label: "机加工", value: 3 },
        { label: "测试", value: 4 },
        { label: "包装", value: 5 },
        { label: "仓储分拣", value: 6 },
        { label: "检验", value: 7 },
      ],
      stationStatusOptions: [
        { label: "停用", value: 0 },
        { label: "正常", value: 1 },
        { label: "检修", value: 2 },
        { label: "调试中", value: 3 },
      ],
      traceLevelOptions: [
        { label: "简易追溯", value: 1 },
        { label: "完整工单追溯", value: 2 },
        { label: "全参数采集追溯", value: 3 },
      ],
      station: {},
      ruleValidate: {
        stationName: { required: true, message: "请输入工位全称", trigger: "blur" },
        lineID: { required: true, message: "请选择所属产线", trigger: "change" },
        stationType: { required: true, message: "请选择工位类型", trigger: "change" },
        stationStatus: { required: true, message: "请选择工位状态", trigger: "change" },
      },
    };
  },
  methods: {
    resetForm() {
      this.$refs.form && this.$refs.form.resetFields();
    },
    open(row) {
      this.dialogVisible = true;
      this.lineName = row ? row.lineName || "" : "";
      this.processName = row ? row.processName || "" : "";
      this.station = Object.assign(
        {
          id: undefined,
          factoryID: 0,
          workshopID: 0,
          lineID: 0,
          processID: 0,
          cellID: 0,
          stationCode: "",
          stationERPCode: "",
          stationWMSCode: "",
          stationWCSCode: "",
          stationSCADACode: "",
          stationName: "",
          stationShortName: "",
          stationEnglishName: "",
          stationType: 1,
          stationSubType: undefined,
          isAutoStation: false,
          isSemiAuto: false,
          isKeyStation: false,
          isNeedWorker: true,
          isNeedLogin: true,
          standardTaktSec: undefined,
          standardHourOutput: undefined,
          currentWorkerID: undefined,
          standardWorkerNum: undefined,
          maxWorkerNum: undefined,
          isKeyProcess: false,
          needFirstArticleCheck: false,
          needIPQC: false,
          traceLevel: 2,
          inheritCleanConfig: true,
          customCleanLevel: "",
          customTemp: undefined,
          customHumidity: undefined,
          staticControl: false,
          collectEnable: true,
          collectIP: "",
          collectPort: undefined,
          collectProtocol: 1,
          collectCycleSec: 5,
          stationStatus: 1,
          putIntoUseDate: "",
          stopUseDate: "",
          remark: "",
          extendJson: "",
        },
        row || {}
      );
    },
    selectLine(row) {
      this.station.lineID = row.id;
      this.lineName = row.lineName;
    },
    submitHandle() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .save("basic", "fm/workstation", this.station)
            .then((resp) => {
              this.submitLoading = false;
              if (resp.success) {
                this.$emit("save-success");
                this.$message.success(this.station.id ? "编辑成功" : "添加成功");
                this.dialogVisible = false;
              }
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.fm-section-title {
  font-weight: bold;
  padding: 10px 0 5px;
  margin-bottom: 10px;
  border-bottom: 1px solid #e8e8e8;
  color: #409eff;
}
</style>
